module.exports = __webpack_public_path__ + "static/img/reward_effect3.91d23900.png";